export const trackLeadFormSubmission = (formName) => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "lead_generator",
    form_name: formName,
  });
};
